import { Plus, Trash } from "@phosphor-icons/react";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { CURRENCIES } from "../lib/constants";

// Mirrors backend vendor_item_cost: the vendor's price in the PO currency, else the item card's cost.
export const vendorItemCost = (item, vendorId, currency) => {
  const cur = (currency || "").toUpperCase() || "AUD";
  const vp = (item?.vendor_prices || []).find((p) => p.vendor_id === vendorId && ((p.currency || "").toUpperCase() || "AUD") === cur);
  return vp ? Number(vp.cost || 0) : Number(item?.cost || 0);
};

export const VendorPricesEditor = ({ rows, onChange, vendors, disabled }) => {
  const set = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="md:col-span-2" data-testid="vendor-prices">
      <p className="text-xs text-muted-foreground mb-2">A vendor's saved price is used on that vendor's purchase orders in the same currency. Otherwise the Unit Cost above is used.</p>
      {rows.length > 0 && (
        <div className="space-y-2 mb-2">
          {rows.map((r, i) => (
            <div key={i} className="grid grid-cols-[1fr_9rem_8rem_2rem] gap-2 items-center" data-testid="vendor-price-row">
              <Select value={r.vendor_id || "none"} onValueChange={(v) => set(i, "vendor_id", v === "none" ? "" : v)} disabled={disabled}>
                <SelectTrigger className="rounded-sm h-9" data-testid="vendor-price-vendor"><SelectValue placeholder="Vendor" /></SelectTrigger>
                <SelectContent><SelectItem value="none">— Vendor —</SelectItem>{vendors.map((v) => <SelectItem key={v.id} value={v.id}>{v.name}</SelectItem>)}</SelectContent>
              </Select>
              <Select value={r.currency || "none"} onValueChange={(v) => set(i, "currency", v === "none" ? "" : v)} disabled={disabled}>
                <SelectTrigger className="rounded-sm h-9" data-testid="vendor-price-currency"><SelectValue placeholder="Currency" /></SelectTrigger>
                <SelectContent><SelectItem value="none">— None —</SelectItem>{CURRENCIES.map((c) => <SelectItem key={c.code} value={c.code}>{c.code}</SelectItem>)}</SelectContent>
              </Select>
              <Input type="number" step="0.01" value={r.cost} onChange={(e) => set(i, "cost", e.target.value)} className="rounded-sm h-9 num text-right" data-testid="vendor-price-cost" />
              {!disabled && <button type="button" onClick={() => onChange(rows.filter((_, j) => j !== i))} className="p-1.5 text-muted-foreground hover:text-destructive" data-testid="vendor-price-remove"><Trash size={15} /></button>}
            </div>
          ))}
        </div>
      )}
      {!disabled && (
        <button type="button" onClick={() => onChange([...rows, { vendor_id: "", currency: "", cost: 0 }])} className="inline-flex items-center gap-1 text-xs font-semibold text-primary hover:underline" data-testid="vendor-price-add">
          <Plus size={13} weight="bold" /> Add vendor price
        </button>
      )}
    </div>
  );
};
